'use client';

import { useEffect } from 'react';
import Link from 'next/link';

// Error boundary a livello di pagina: il layout (header, footer, <title>,
// lang) resta al suo posto anche se un componente va in errore.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main id="main-content" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-secondary-50 to-white px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-semibold text-secondary-700 mb-4">
          Si è verificato un errore
        </h1>
        <p className="text-secondary-400 mb-8">
          Non è stato possibile caricare questa pagina. Riprova tra qualche istante.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={reset}
            className="inline-flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Riprova
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 border border-secondary-200 text-secondary-600 hover:bg-secondary-50 font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Torna alla home
          </Link>
        </div>
      </div>
    </main>
  );
}
